<div class="dialog_container">
  <div class="header_row">
    <div class="header_left"></div>
    <span class="close" (click)="close()">✕</span>
    <h3 id="header_title" style="text-align: center">{{ title }}</h3>
  </div>
  <br />
  <h5 style="padding-top: 10px">{{ subLine }}</h5>
  <br />
  <p style="padding-top: 10px; text-align: left">{{ description }}</p>
  <br />
  @if (completionRate) {
    <div style="display: flex; align-items: center">
      <h5 style="padding-right: 10px">
        {{
          'DIALOGS.INFORMATION.CANCELLATION_POLICY.TASKER.CURRENT_COMPLETION_RATE'
            | translate
        }}
      </h5>
      <h3>{{ completionRate }}%</h3>
    </div>
  }
</div>
